export default function getWarrentyNumber (order) {
  if (!order) return
  if (order.isKaufschutz || !order.product.rate || !order.product.rate.product || !order.product.rate.product.hn) {
    return `${order.contract.warrantyNumber}`
  } else {
    return `${order.product.rate.product.hn}-${order.contract.warrantyNumber}`
  }
}
